"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import LoanCalculator from "@/components/common/LoanCalculator";

export default function HomePageLoanCalculator() {
  const t = useTranslations();
  const min = 100000;
  const max = 5000000;
  const step = 10000;

  const [amount, setAmount] = useState(300000);
  const pct = ((amount - min) / (max - min)) * 100;

  return (
    <LoanCalculator
      amount={amount}
      setAmount={setAmount}
      min={min}
      max={max}
      step={step}
      pct={pct}
      t={t}
    />
  );
}
